export default __webpack_public_path__ + "static/media/grey_search_icon.0747d1cb.svg";